module.exports = __webpack_public_path__ + "static/media/icon-surface.7662b8ee.svg";